export default __webpack_public_path__ + "c696447c801b5a7109699e4f98449455.svg";